import { FilterType, getFilmById, getFilterByIdAndType, hasValidValuesForFilter } from '@vista/omnichannel-components-domain';
export const filterScreeningDates = (screeningDates, filterId) => {
    const filter = getFilterByIdAndType(filterId, FilterType.Showtime);
    if (!filter)
        return screeningDates;
    return screeningDates.reduce((acc, screeningDate) => {
        const validFilmScreenings = filterFilmScreenings(screeningDate.filmScreenings, filter);
        const updatedScreeningDate = Object.assign(Object.assign({}, screeningDate), { filmScreenings: validFilmScreenings });
        return validFilmScreenings.length ? [...acc, updatedScreeningDate] : acc;
    }, []);
};
const filterFilmScreenings = (filmScreenings, filter) => {
    return filmScreenings.reduce((acc, filmScreening) => {
        const film = getFilmById(filmScreening.filmId);
        const validFilm = !!film && hasValidValuesForFilter(filter.sections.genre, film.genreIds);
        const validSites = filmScreening.sites.filter(site => hasValidValuesForFilter(filter.sections.attribute, site.showtimeAttributeIds));
        const validFilmScreening = validFilm && validSites.length > 0;
        const updatedFilmScreening = Object.assign(Object.assign({}, filmScreening), { sites: validSites });
        return validFilmScreening ? [...acc, updatedFilmScreening] : acc;
    }, []);
};
